import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CreateButton from '../buttons/CreateButton';
import withPrivileges from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';
import CurrencyCreateTab from './CurrencyCreateTab';

function CreateCurrencyRow() {
    const { t } = useTranslation();
    const [isCreateVisible, setCreateVisible] = useState(false);
    const actionHandler = () => setCreateVisible(!isCreateVisible);
    return (
        <div className="create-currency-row">
            <CreateButton onAction={actionHandler} isCreateVisible={isCreateVisible}><FontAwesomeIcon icon="plus" />&nbsp;{t('currencies.create-currency')}
            </CreateButton>
            {isCreateVisible && <CurrencyCreateTab hideHandler={() => setCreateVisible(false)} />}
        </div>
    );
}

export default withPrivileges([Privileges.CURRENCY_EDIT])(CreateCurrencyRow);
